import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Memuat kamus terjemahan dari `src/assets/i18n/{lang}.json`.
 * `angular.json` sudah menyalin seluruh `src/assets`, jadi tidak perlu
 * konfigurasi build tambahan.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`assets/i18n/${lang}.json`);
  }
}
